"use client";

import { LandingDeferredSectionSkeleton } from "@marketing/home/components/landing-deferred-section-skeleton";
import { LandingIntersectionDeferredSection } from "@marketing/home/components/landing-intersection-deferred-section";
import { triggerSolutionDemoEarlyPreload } from "@marketing/home/lib/solution-demo-early-preload";
import dynamic from "next/dynamic";

function deferredLoading(minHeightClass: string) {
	return function LandingDeferredLoading() {
		return (
			<LandingDeferredSectionSkeleton minHeightClass={minHeightClass} />
		);
	};
}

const LandingLogos = dynamic(
	() => import("./landing-logos").then((m) => ({ default: m.LandingLogos })),
	{ loading: deferredLoading("min-h-[160px]") },
);

const LandingProblems = dynamic(
	() =>
		import("./landing-problems").then((m) => ({
			default: m.LandingProblems,
		})),
	{ loading: deferredLoading("min-h-[720px]") },
);

const LandingMission = dynamic(
	() =>
		import("./landing-mission").then((m) => ({
			default: m.LandingMission,
		})),
	{ loading: deferredLoading("min-h-[560px]") },
);

const SolutionDemo = dynamic(
	() =>
		import("./solution-demo").then((m) => ({
			default: m.SolutionDemo,
		})),
	{ loading: deferredLoading("min-h-[920px]") },
);

const LandingFeatures = dynamic(
	() =>
		import("./landing-features").then((m) => ({
			default: m.LandingFeatures,
		})),
	{ loading: deferredLoading("min-h-[680px]") },
);

const LandingTestimonials = dynamic(
	() =>
		import("./landing-testimonials").then((m) => ({
			default: m.LandingTestimonials,
		})),
	{ loading: deferredLoading("min-h-[520px]") },
);

const LandingCallToAction = dynamic(
	() =>
		import("./landing-call-to-action").then((m) => ({
			default: m.LandingCallToAction,
		})),
	{ loading: deferredLoading("min-h-[440px]") },
);

const LandingFaqs = dynamic(
	() => import("./landing-faqs").then((m) => ({ default: m.LandingFaqs })),
	{ loading: deferredLoading("min-h-[520px]") },
);

export function LandingHomeBelowFoldSections() {
	return (
		<>
			<LandingIntersectionDeferredSection
				minHeightClass="min-h-[160px]"
				rootMargin="0px 0px 320px 0px"
			>
				<LandingLogos />
			</LandingIntersectionDeferredSection>
			<LandingIntersectionDeferredSection
				minHeightClass="min-h-[720px]"
				rootMargin="0px 0px 280px 0px"
			>
				<LandingProblems />
			</LandingIntersectionDeferredSection>
			<LandingIntersectionDeferredSection
				minHeightClass="min-h-[560px]"
				rootMargin="0px 0px 360px 0px"
			>
				<LandingMission />
			</LandingIntersectionDeferredSection>
			<LandingIntersectionDeferredSection
				minHeightClass="min-h-[920px]"
				rootMargin="0px 0px 400px 0px"
				onBecomeVisible={triggerSolutionDemoEarlyPreload}
			>
				<SolutionDemo />
			</LandingIntersectionDeferredSection>
			<LandingIntersectionDeferredSection
				minHeightClass="min-h-[680px]"
				rootMargin="0px 0px 240px 0px"
			>
				<LandingFeatures />
			</LandingIntersectionDeferredSection>
			<LandingIntersectionDeferredSection
				minHeightClass="min-h-[520px]"
				rootMargin="0px 0px 200px 0px"
			>
				<LandingTestimonials />
			</LandingIntersectionDeferredSection>
			<LandingIntersectionDeferredSection
				minHeightClass="min-h-[440px]"
				rootMargin="0px 0px 180px 0px"
			>
				<LandingCallToAction />
			</LandingIntersectionDeferredSection>
			<LandingIntersectionDeferredSection
				minHeightClass="min-h-[520px]"
				rootMargin="0px 0px 160px 0px"
			>
				<LandingFaqs />
			</LandingIntersectionDeferredSection>
		</>
	);
}
